import React, {useState, useRef, useEffect} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { 
    Flex, Box, VStack, FormControl, FormLabel, Input, Button, ButtonGroup, Text,
    Select, Checkbox, Textarea, Tabs, Tab, TabList, TabPanels, TabPanel,
} from '@chakra-ui/react';
import { withNamespaces } from 'react-i18next';

import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.module.css';

import { ACTIVE_HOME_TAB } from '../redux/constants';
import { WORK_HOURLY_LIST, SELECTED_CLINIC_MAX_AGE } from '../constants';
import { setNavTab } from '../redux/actions';
import { apiLoadListCompany } from '../redux/apis';
import { apiLoadASystemSettingByCompanyId } from '../redux/apis/SystemSettingApis';
import { getCurrentNavTab, getCompanyList, getASystemSetting } from '../redux/selectors';
import { displayConfirmChoiceAlert, displayConfirmChoiceAlert2 } from './utils';

import Header from './Home/Header';
import Navbar from './Home/Navbar';
import BrandName from '../components/BrandName';
import NewPatient from './Home/RegisterMedical/NewPatient';
import RegisteredPatient from './Home/RegisterMedical/RegisteredPatient';
import SelectWithImage from '../components/SelectWithImage';

function Home(props) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["selectedClinic", "makeDoctorAppointmentDatas"]);
    const [ selectedCompanyId, setSelectedCompanyId ] = useState(0);
    const [ scheduleDate, setScheduleDate ] = useState(new Date());
    const [ selectedMedicalTime, setSelectedMedicalTime ] = useState("");
    const [ reasonNeedDoctor, setReasonNeedDoctor ] = useState("");
    const [ tabIdx, setTabIdx] = useState(0);
    const [ workHourlyList, setWorkHourlyList ] = useState({});
    const [ companyListSelect, setCompanyListSelect ] = useState([]);
    const mounted = useRef();
    // i18next
    const t = props.t;

    useEffect(() => {
        if(!mounted.current) {
            props.apiLoadListCompany({ order_by: "name", order_dir: "ASC" });
            props.setNavTab(ACTIVE_HOME_TAB);

            if(cookies.selectedClinic?.data?.id) {
                setSelectedCompanyId(cookies.selectedClinic?.data?.id);
                props.apiLoadASystemSettingByCompanyId({ company_id: cookies?.selectedClinic?.data?.id });
            }

            if(cookies.makeDoctorAppointmentDatas?.data) {
                const { isNewRegister, scheduleDate, selectedMedicalTime, reasonNeedDoctor } = cookies.makeDoctorAppointmentDatas?.data;
                setScheduleDate(scheduleDate);
                setSelectedMedicalTime(selectedMedicalTime);
                setReasonNeedDoctor(reasonNeedDoctor);

                setTabIdx(isNewRegister ? 0 : 1);
            }

            mounted.current = true;
        }
    });

    useEffect(() => {
        const _WORK_HOURLY_LIST = props.systemSettingDetail?.daily_time_schedules?.work_hourly || WORK_HOURLY_LIST;
        const _workHourlyList = {};
        
        Object.keys(_WORK_HOURLY_LIST).map(key => {
            if(_WORK_HOURLY_LIST[key]) {
                _workHourlyList[key] = true;
            }
        })
        setWorkHourlyList(_workHourlyList);
        setCookie("selectedClinic", 
            { 
                data: {
                    ...cookies.selectedClinic?.data,
                    systemSettingDetail: props.systemSettingDetail
                } 
            }, 
            { 
                path: '/', maxAge: SELECTED_CLINIC_MAX_AGE 
            }
        );
    }, [props.systemSettingDetail]);

    useEffect(() => {
        const _companyListSelect = props.companyList.map(item => ({
            label: item.name,
            value: item.id,
            icon: `${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/companies/${item.logo_url}`
        }));
        setCompanyListSelect(_companyListSelect);
    }, [props.companyList]);

    const handleSelectedClinic = (value) => {
        const reloadCompanyData = () => {
            let firstCompany = props.companyList.find(item => item.id == value);
            props.apiLoadASystemSettingByCompanyId({ company_id: firstCompany?.id });
            setCookie("selectedClinic", { data: firstCompany }, { path: '/', maxAge: SELECTED_CLINIC_MAX_AGE });
            setSelectedCompanyId(value);
        }

        if(cookies.makeDoctorAppointmentDatas?.data && cookies.makeDoctorAppointmentDatas?.data?.company_id !== value) {
            displayConfirmChoiceAlert(
                "Khi thay đổi phòng khám, các thông tin mà bạn đã chọn sẽ bị mất. Bạn có đồng ý?", 
                () => {
                    removeCookie("makeDoctorAppointmentDatas");
                    reloadCompanyData();
                    window.location.reload();
                }
            )
        } else {
            reloadCompanyData();
        }
    }

    return (
        <React.Fragment>
            <Box>
                <Header />
                <Navbar />

                {/* <Box width="100%" height="100%" backgroundImage="/images/clinic-bg.jpeg" px={2} py={2}> */}
                <Box borderRadius={4} bg="#ffffff" px={2} py={2} boxShadow="md">
                    <Flex flexDirection={{ base: "column", md: "column", lg: "row" }} gap={4}>
                        <Flex flexDirection="column" width={{ base: "90vw", md: "90vw", lg: "30vw" }}>
                            <Text>{t("Select_Clinic")} <span style={{ color: "red" }}>*</span></Text>
                            <SelectWithImage id={selectedCompanyId} title="phòng khám" datas={companyListSelect} onChange={handleSelectedClinic}/>
                        </Flex>

                        <Flex flexDirection="column">
                            <Text>{t("Schedule_Date")} <span style={{ color: "red" }}>*</span></Text>
                            <DatePicker
                                placeholderText={t("Schedule_Date")}
                                dateFormat="dd/MM/yyyy" 
                                selected={scheduleDate}
                                minDate={new Date()}
                                showIcon
                                className='date-picker'
                                onChange={
                                    (date) => {
                                        setScheduleDate(date);
                                    }
                                }
                            />
                        </Flex>

                        <Flex flexDirection="column">
                            <Text>{t("Schedule_Hour")} <span style={{ color: "red" }}>*</span></Text>
                            <Select placeholder={t("Schedule_Hour")} value={selectedMedicalTime}
                                onChange={
                                    (evt) => {
                                        setSelectedMedicalTime(evt.target.value);
                                    }
                                }
                            >
                                {
                                    Object.keys(workHourlyList).map(key => (
                                        <React.Fragment key={key}>
                                            <option value={key}>{key}</option>
                                        </React.Fragment>
                                    ))
                                }
                            </Select>
                        </Flex>

                        <Flex flexDirection="column">
                            <Text>{t("Schedule_Reason")} <span style={{ color: "red" }}>*</span></Text>
                            <Textarea value={reasonNeedDoctor} placeholder={t("Schedule_Reason")} rows={3} minW="300px"
                                onChange={(evt) => setReasonNeedDoctor(evt.currentTarget.value)}
                            />
                        </Flex>
                    </Flex>

                    {/* <Flex flexDirection={{ base: "column", md: "column", lg: "row" }} justifyContent="flex-start" gap={2} mt={2}>
                        <VStack align="flex-start" justify="flex-start" px={2}>
                            <Field name="BHXH">
                                {({ input, meta }) => (
                                    <Checkbox {...input}>Có BHYT</Checkbox>
                                )}
                            </Field>
                            <Field name="NoBHXH">
                                {({ input, meta }) => (
                                    <Checkbox {...input}>Không BHYT</Checkbox>
                                )}
                            </Field>
                        </VStack>

                        <VStack align="flex-start" justify="flex-start" px={2}>
                            <Field name="KhamTheoYeuCau">
                                {({ input, meta }) => (
                                    <Checkbox {...input}>Khám theo yêu cầu (chưa biết bệnh)</Checkbox>
                                )}
                            </Field>
                            <Field name="KhamDichVuChuyenKhoa">
                                {({ input, meta }) => (
                                    <Checkbox {...input}>Khám dịch vụ chuyên khoa</Checkbox>
                                )}
                            </Field>
                        </VStack>

                        <VStack align="flex-start" px={2}>
                            <Field name="KhamSucKhoeTongQuat">
                                {({ input, meta }) => (
                                    <Checkbox {...input}>Khám sức khoẻ tổng quát</Checkbox>
                                )}
                            </Field>
                            <Field name="KhamDichVuVip">
                                {({ input, meta }) => (
                                    <Checkbox {...input}>Khám dịch vụ <span style={{ color: "red", fontWeight: 700 }}>VIP</span></Checkbox>
                                )}
                            </Field>
                        </VStack>
                    </Flex> */}
                </Box>

                <Box borderRadius={8} bg="#ffffff" minH="500px" px={2} py={2} marginTop={4}>
                    <Text fontSize="16px" fontWeight="700" color="#007F4E">{t("Register_Information")}</Text>
                    <Tabs index={tabIdx} variant="soft-rounded" colorScheme='green' p={2} onChange={(tabIdx) => setTabIdx(tabIdx)}>
                        <TabList>
                            <Tab value={0}>{t("New_Register")}</Tab>
                            <Tab value={1}>{t("Already_Register")}</Tab>
                        </TabList>
                        <TabPanels>
                            <TabPanel>
                                <NewPatient 
                                    selectedClinic={selectedCompanyId} scheduleDate={scheduleDate} 
                                    selectedMedicalTime={selectedMedicalTime} reasonNeedDoctor={reasonNeedDoctor}
                                    t={t}
                                />
                            </TabPanel>
                            <TabPanel>
                                <RegisteredPatient 
                                    selectedClinic={selectedCompanyId} scheduleDate={scheduleDate} 
                                    selectedMedicalTime={selectedMedicalTime} reasonNeedDoctor={reasonNeedDoctor}
                                    t={t}
                                />
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </Box>
            </Box>
            <BrandName />
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    const companyList =             getCompanyList(state);
    const currentNavTab =           getCurrentNavTab(state);
    const systemSettingDetail   =   getASystemSetting(state);

    return { companyList, currentNavTab, systemSettingDetail };
}

export default connect(mapStateToProps, { setNavTab, apiLoadListCompany, apiLoadASystemSettingByCompanyId, })(withNamespaces()(Home));